<div class="waiting-container">
  <span>{{ waitingUser()?.firstName }} {{ waitingUser()?.lastName || '' }} </span>
  <div class="buttons-section">
    <a class="option-button admit-button" (click)="admitUser()"> ADMIT </a>
    <a class="option-button remove-button" (click)="removeUser()"> REMOVE </a>
  </div>
</div>
